import type { Tracker, TrackingEvent } from '@archipro-website/tracker';

interface SearchTileTrackData {
    index: number; // start from 0
    columnPerRow: number;
}

/**
 * @deprecated This was used in the old search page before Rocco.
 */
export const fireSearchTileEvent = (
    event: TrackingEvent,
    url: string,
    data: SearchTileTrackData,
    tracker: Tracker,
) => {
    const { index, columnPerRow } = data;
    if (columnPerRow <= 0) {
        return;
    }
    const row = Math.floor(index / columnPerRow) + 1;
    const column = (index % columnPerRow) + 1;
    const position = index + 1;

    tracker.log(event, {
        url: new URL(url),
        label: url,
        targetTracker: 'archiproTracker',
        data: {
            // format: [Row,Column,CountPerRow,AbsolutePosition]
            ExtraData: JSON.stringify([row, column, columnPerRow, position]),
        },
    });
};
